module.exports = __webpack_public_path__ + "static/img/1-1.bab9ae3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/1-1.png
// module id = D4eZ
// module chunks = 0